import { CONFIG } from '../config.js';

/** Bucle de requestAnimationFrame que entrega dt en segundos, acotado. */
export class Loop {
  constructor(onFrame) {
    this.onFrame = onFrame;
    this.last = 0;
    this.running = false;
    this.tick = this.tick.bind(this);
    document.addEventListener('visibilitychange', () => {
      // Al volver de segundo plano no queremos un dt gigante.
      this.last = performance.now();
    });
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    requestAnimationFrame(this.tick);
  }

  tick(now) {
    if (!this.running) return;
    const dt = Math.min((now - this.last) / 1000, CONFIG.sim.maxFrame);
    this.last = now;
    this.onFrame(Math.max(dt, 0));
    requestAnimationFrame(this.tick);
  }
}
